const forms = document.querySelectorAll('.gform_wrapper');

function toggleLabel() {
  const inputs = document.querySelectorAll('.ginput_container input, .ginput_container textarea');

  inputs.forEach((input) => {
    const label = input.parentElement.previousElementSibling;
    const submitBtn = document.querySelector('.gform_footer button')

    const checkAndToggleLabel = () => {
      if (input.value.trim() === '' && !input.matches(':focus')) {
        label.style.display = 'block';
      } else {
        label.style.display = 'none';
      }
    };

    const checkPhone = () => {
      if (input.parentElement.classList.contains('ginput_container_phone') && input.value.includes('_')) {
        label.style.display = 'block';
      }
    }

    input.addEventListener('focus', () => {
      label.style.display = 'none';
    });

    input.addEventListener('blur', () => {
      checkAndToggleLabel();
      checkPhone();
    });

    submitBtn.addEventListener('click', () => {
      checkPhone();
    })

    checkAndToggleLabel();
  });
}

forms.forEach((form) => {
  if (form) {
    toggleLabel();
  }
})

function initLabel() {
  forms.forEach((form) => {
    if (form) {
      jQuery(document).on('gform_page_loaded', function () {
        toggleLabel();
      });
    }
  })
}

export {
  initLabel,
}
